<template>
  <div class="container-page big">
    <div class="title-block-top title-block-top--full">
      <div class="title-block-top__first title-block-top__first--full">
        <h2 class="title title--h2 title--subtask cross-cutting-tasks__title">
          <router-link :to="{ name: 'analytics-cross-cutting-task-detail', params: { id: taskId } }" class="text-title">
            {{ nameTask }}
          </router-link>
          <router-link :to="{ name: 'cross-cutting-task', params: { id: countryId } }" class="text-dot">
            <span class="text-dot__bullet" aria-hidden="true"></span>
            <span class="text-dot__text">{{ getNameCountry }}</span>
            <span class="country-flag text-dot__flag">
              <img :src="getImageCountry" alt="country-flag" width="45" height="30" />
            </span>
          </router-link>
        </h2>
      </div>
      <div class="title-block-top__second title-block-top__second--full">
        <div class="cross-cutting-tasks-button">
          <div class="cross-cutting-tasks-button__left">
            <ButtonComponent
              v-permission="permissions.edit"
              v-if="getEditSubtasksPermission"
              @click="onOpenEditSubtaskPopup"
              mod="gradient-bg"
              class="button-redesign--mobile-full"
              >Редактировать подзадачи</ButtonComponent
            >
          </div>
          <div class="cross-cutting-tasks-button__right">
            <ButtonComponent
              v-permission="permissions.createRequest"
              @click="onOpenCreateRequestPopup"
              mod="gradient-bg"
              class="button-redesign--mobile-full"
              >Создать запрос</ButtonComponent
            >
          </div>
        </div>
      </div>
    </div>

    <div class="cross-cutting-tasks-card">
      <div class="cross-cutting-tasks-card__header">
        <div class="cross-cutting-tasks-card__text-block"></div>
        <div class="cross-cutting-tasks-card__done">
          <div class="cross-cutting-tasks-card__done-text">Вес подзадачи</div>
        </div>
        <div class="cross-cutting-tasks-card__weight">
          <div class="cross-cutting-tasks-card__weight-text">Выполнение</div>
        </div>
      </div>
      <div class="cross-cutting-tasks-card__item" v-for="(item, index) in sortedSubtasks" :key="index" :id="item.id">
        <div class="cross-cutting-tasks-card__text-block">
          <div class="cross-cutting-tasks-card__title">{{ item.name }}</div>
          <div class="cross-cutting-tasks-card__description">{{ item.comment }}</div>
        </div>
        <div class="cross-cutting-tasks-card__done">
          <div class="cross-cutting-tasks-card__weight-title">{{ changePoints(item.weight) }}</div>
        </div>
        <div class="cross-cutting-tasks-card__weight">
          <div class="cross-cutting-tasks-card__weight-content">
            <div
              :title="item.completionPercentage.toString().length > 5 ? `${item.completionPercentage}%` : null"
              :class="[
                'cross-cutting-tasks-card__done-title',
                getCompletionPercentageColorClass(item.completionPercentage),
              ]"
            >
              {{ getItemCompletionPercentage(item.completionPercentage) }}%
            </div>
          </div>
          <div class="cross-cutting-tasks-card__tooltip-cell">
            <span class="cross-cutting-tasks-card__problem-col">
              <Tooltip
                v-if="item.problem"
                nameIcon="error"
                modContent="width-600"
                position="top"
                :triggers="['click']"
                class="problem-tooltip tooltip-component--mobile-big"
              >
                <div>{{ item.problem }}</div>
              </Tooltip>
            </span>
          </div>
        </div>
      </div>
    </div>
    <ModalComponent
      title="Форма создания запроса"
      contentClass="modal--new"
      width="1064"
      :themeLigth="true"
      v-model="createPopupRequest"
      @close="closePopupRequest"
      @update:modelValue="closePopupRequest"
    >
      <FormCreateRequest
        :nameTask="nameTask"
        :optionEmployees="optionEmployees"
        :optionCountry="optionCountry"
        :optionResponsibleFOIV="optionResponsibleFOIV"
        :errorCreate="errorCreate"
        @submit="createRequest"
        @close="closePopupRequest"
        ref="popupFormCreateRequest"
        :disabledButton="disabledButtonPopupRequest"
      />
    </ModalComponent>

    <ModalComponent
      title="Редактирование подзадачи"
      contentClass="modal--new modal--edit-subtask"
      width="1064"
      :themeLigth="true"
      v-model="editSubtaskPopup"
      @close="onCloseEditSubtaskPopup"
      @update:modelValue="onCloseEditSubtaskPopup"
    >
      <FormEditSubtask
        :subtaskList="arraySubtasksFormat"
        :editWeightPermission="getEditWeightPermission"
        :errorEdit="errorEdit"
        @submit="editSubtask"
        @close="onCloseEditSubtaskPopup"
        ref="popupEditSubtask"
      />
    </ModalComponent>

    <ModalComponent
      :title="getTitleCardRequest"
      contentClass="modal--new"
      width="1064"
      :themeLigth="true"
      v-model="cardRequestPopup"
      @close="onCloseCardRequestCardRequestPopup"
      @update:modelValue="onCloseCardRequestCardRequestPopup"
    >
      <CardRequest :info="infoCardRequest" />
    </ModalComponent>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import showHideScroll from '@/common/mixins/showHideScroll';
  import Tooltip from '@/common/ui/Tooltip.vue';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import CardRequest from '@/modules/crossCuttingTask/components/CardRequest.vue';
  import FormEditSubtask from '@/modules/crossCuttingTask/components/FormEditSubtask.vue';

  import API from '../api';
  import FormCreateRequest from '../components/FormCreateRequest.vue';

  const PERMISSIONS = {
    view: Constants.Permissions.AccessCrossCuttingTask,
    edit: Constants.Permissions.CrossCuttingTaskEdit,
    createRequest: Constants.Permissions.AccessToCreatingRequestCrossCuttingTask,
  };

  export default {
    name: 'PageTaskCard',
    components: {
      ModalComponent,
      FormCreateRequest,
      FormEditSubtask,
      CardRequest,
      ButtonComponent,
      Tooltip,
    },
    mixins: [showHideScroll, security],
    data() {
      return {
        countryId: 0,
        taskId: 0,
        nameTask: '',
        arraySubtask: [],
        createPopupRequest: false,
        editSubtaskPopup: false,
        optionEmployees: [],
        optionCountry: [],
        optionResponsibleFOIV: [],
        currentCountry: {},
        errorCreate: false,
        numberRequest: 1,
        cardRequestPopup: false,
        infoCardRequest: {},
        errorEdit: false,
        arraySubtasksFormat: [],
        disabledButtonPopupRequest: false,
        canEditWeight: false,
        canEditTask: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.countryId = this.$route?.params?.id || 0;
      this.taskId = this.$route?.params?.task || 0;

      this.loadPage();

      API.getListCountries({ taskId: this.taskId }).then((response) => {
        if (response?.data) {
          this.optionCountry = response.data.map((i) => ({ value: i.id, label: i.name }));
        }
      });

      API.getListEmployees().then((response) => {
        if (response?.data.length) {
          this.optionEmployees = response.data.map((i) => ({
            id: i.id,
            text: i.text,
          }));
        }
      });

      API.getListFOIV({
        pageNumber: 1,
        typeIds: 1,
        isActive: true,
      }).then((response) => {
        const { items = [] } = response.data;
        if (items.length) {
          this.optionResponsibleFOIV = items.map((i) => ({
            id: i.id,
            text: i.name,
          }));
        }
      });
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
      getNameCountry() {
        return this.currentCountry?.name || '';
      },

      getImageCountry() {
        return this.currentCountry?.picture || '';
      },

      getTitleCardRequest() {
        return `Запрос №${this.numberRequest}`;
      },

      getEditWeightPermission() {
        return this.canEditWeight;
      },
      getEditSubtasksPermission() {
        return this.canEditTask;
      },
      sortedSubtasks() {
        const subtasksCopy = [...(this.arraySubtask || [])];
        return subtasksCopy.sort((firstSubtask, secondSubtask) => {
          const firstCompletion = Number(firstSubtask?.completionPercentage || 0);
          const secondCompletion = Number(secondSubtask?.completionPercentage || 0);
          if (firstCompletion !== secondCompletion) return secondCompletion - firstCompletion;
          return String(firstSubtask?.name || '').localeCompare(String(secondSubtask?.name || ''), 'ru');
        });
      },
    },
    watch: {
      errorCreate(val) {
        if (val) {
          setTimeout(() => {
            this.errorCreate = false;
          }, 5000);
        }
      },

      errorEdit(val) {
        if (val) {
          setTimeout(() => {
            this.errorEdit = false;
          }, 5000);
        }
      },
    },
    methods: {
      loadPage() {
        API.getInfoPageTaskCard({ countryId: this.countryId, taskId: this.taskId }).then((response) => {
          if (response?.data) {
            const { subtasks = [], country = [], taskName = '', canEditWeigth, canEditTask = false } = response.data;
            this.arraySubtask = subtasks;
            this.currentCountry = country;
            this.nameTask = taskName;
            this.canEditWeight = canEditWeigth;
            this.canEditTask = canEditTask;
          }
        });
      },

      onOpenEditSubtaskPopup() {
        if (this.arraySubtask.length) {
          this.arraySubtasksFormat = this.arraySubtask.map((i) => ({
            comment: i.comment,
            completionPercentage: i.completionPercentage,
            name: i.name,
            weight: i.weight,
            problem: i.problem,
            id: i.id,
          }));
        }

        this.editSubtaskPopup = true;
        this.hiddenBodyScroll();
      },

      editSubtask(data) {
        API.putEditSubtask({
          head: {
            countryId: +this.countryId,
          },
          body: data,
        })
          .then(() => {
            this.loadPage();
            this.onCloseEditSubtaskPopup();
          })
          .catch((err) => {
            console.error('error methods createRequest', err);
            this.errorEdit = true;
          });
      },

      onCloseEditSubtaskPopup() {
        this.editSubtaskPopup = false;
        this.$refs.popupEditSubtask.reset();
        this.showBodyScroll();
      },

      onOpenCreateRequestPopup() {
        this.createPopupRequest = true;
        this.hiddenBodyScroll();
      },

      closePopupRequest() {
        this.createPopupRequest = false;
        this.$refs.popupFormCreateRequest.reset();
        this.showBodyScroll();
      },

      createRequest(data) {
        this.disabledButtonPopupRequest = true;
        API.postCreateRequest({ crossCuttingTaskId: this.taskId, ...data })
          .then((res) => {
            this.numberRequest = res?.data?.id || 1;
            this.infoCardRequest = data;
            this.closePopupRequest();
            this.cardRequestPopup = true;
            this.hiddenBodyScroll();
          })
          .catch((err) => {
            console.error('error methods createRequest', err);
            this.errorCreate = true;
          })
          .finally(() => {
            this.disabledButtonPopupRequest = false;
          });
      },

      onCloseCardRequestCardRequestPopup() {
        this.cardRequestPopup = false;
        this.showBodyScroll();
      },

      changePoints(item) {
        return String(item).replace(/\./g, ',');
      },

      getItemCompletionPercentage(completionPercentage) {
        if (completionPercentage % 1 === 0) {
          return completionPercentage;
        } else {
          const parts = completionPercentage.toString().split('.');
          const integerPart = parts[0];
          const fractionalPart = parts[1] || '';
          const firstTwoDigits = fractionalPart.substring(0, 2);
          const needsEllipsis = fractionalPart.length > 2;

          let numberWithDot = integerPart + ',' + firstTwoDigits;
          if (needsEllipsis) {
            numberWithDot += '...';
          }

          return numberWithDot;
        }
      },
      getCompletionPercentageColorClass(completionPercentage) {
        const value = Number(completionPercentage);
        if (!Number.isFinite(value)) return '';
        const percentage = Math.max(0, Math.min(100, value));
        if (percentage <= 30) return 'cross-cutting-tasks-card__done-title--red';
        if (percentage <= 80) return 'cross-cutting-tasks-card__done-title--yellow';
        return 'cross-cutting-tasks-card__done-title--green';
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/title.scss';

  .cross-cutting-tasks-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    &__right {
      display: flex;
      flex-wrap: wrap;
    }

    @media (max-width: $mobile) {
      &__left,
      &__right {
        width: 100%;
      }

      &__left {
        margin-bottom: 8px;
      }

      &__filter {
        margin-top: 8px;
      }
    }
  }

  .country-flag {
    width: 45px;
    height: 30px;
    vertical-align: middle;
    display: inline-block;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    @media (max-width: $laptop) {
      width: 37px;
      height: 24px;
    }
  }

  .text-title {
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
    margin-right: 10px;
    color: inherit;

    &:hover {
      color: $blue;
    }
  }

  .text-dot {
    font-size: inherit;
    line-height: inherit;
    font-family: inherit;
    position: relative;
    vertical-align: baseline;
    padding-left: 16px;
    margin-right: 15px;
    color: inherit;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    &__text {
      font: inherit;

      &:hover {
        color: $blue;
      }
    }

    &__bullet {
      position: absolute;
      left: 0;
      top: 46%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      background: $base;
      border-radius: 50%;
    }

    &__flag {
      margin-left: 8px;
    }

    @media (max-width: $laptop) {
      margin-right: 8px;
    }
  }

  .cross-cutting-tasks__title {
    font: $fira-20-30-B;
    padding-left: 2px;
  }

  .cross-cutting-tasks-card {
    &__header {
      display: flex;
      align-items: flex-end;
      padding-bottom: 24px;
    }

    &__item {
      padding: 24px 0 24px 24px;
      margin-bottom: 24px;
      border-radius: 4px;
      border: 1px solid $grey;
      background: $light-grey;
      display: flex;
      align-items: flex-start;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__title {
      color: inherit;
      font: $fira-20-M;
      margin-bottom: 8px;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__description {
      color: $gray-silver-dark;
      font: $fira-16;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__done,
    &__weight {
      width: 200px;
      margin-left: 16px;
      &-title {
        font: $fira-24-M;
        color: $blue;
      }

      &-text {
        color: $gray-silver-dark;
        font: $fira-16;
      }
    }

    &__done-title {
      &--red {
        color: $red;
      }
      &--yellow {
        color: $yellow;
      }
      &--green {
        color: $approval-text;
      }
    }

    &__weight {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    &__weight-content {
      flex: 1;
    }

    &__tooltip-cell {
      flex: 0 0 40px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }

    &__problem-col {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 24px;
    }

    &__text-block {
      width: calc(100% - (400px + 32px));
      position: relative;
      padding-right: 70px;
    }

    @media (max-width: $tablet) {
      &__done {
        width: 74px;
      }
      &__weight {
        width: 133px;
      }
      &__text-block {
        width: calc(100% - (207px + 32px));
      }
    }

    @media (max-width: $laptop) {
      &__item {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      &__header {
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &__text-block {
        width: 100%;
        margin-bottom: 16px;
      }

      &__done {
        margin-left: 0;
      }

      &__weight {
        margin-left: 0;
      }
      &__title {
        font-size: 16px;
        line-height: 24px;
        padding-right: 40px;
      }

      &__description {
        font-size: 14px;
        line-height: 16px;
      }

      &__text-block {
        padding-right: 0;
      }

      &__done,
      &__weight {
        width: 138px;
        &-title {
          font-size: 20px;
          line-height: 24px;
        }

        &-text {
          font-size: 14px;
          line-height: 16px;
        }
      }
    }

    @media (max-width: $mobile) {
      &__problem-col {
        padding-right: 0;
        margin-top: 6px;
      }

      &__item {
        padding: 16px;
      }
    }
  }

  .problem-tooltip.v-popper--shown :deep(svg),
  .problem-tooltip:hover :deep(svg) {
    border-radius: 50% !important;
  }

  .problem-tooltip.v-popper--shown :deep(svg rect),
  .problem-tooltip:hover :deep(svg rect) {
    stroke: #dc3545 !important;
    fill: #dc3545 !important;
  }
</style>
